/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'


expocadfx.fxevent = function( type, obj) {
    var evt = null;

//    if( typeof( window.Event) === "funciton") {
//        var e = new Event();
//        if( e.initCustomEvent && typeof(e.initCustomEvent) === "function") {
//            console.log( "Event has a initCustomEvent method")
//        }
//    }
    
    if( typeof( window.CustomEvent) === "function") {
        try {
            evt = new CustomEvent( type, {"detail": obj});
            evt.data = obj;
        }
        catch( ex) {
            console.log( "Exception on login event  " + ex.message);
            return null;
        }
    }
    else {
//        console.log( "NO CUSTOMEVENT OBJECT FOUND !!");
        evt = document.createEvent( "Event");
        evt.initEvent( type, true, true);
        evt.data = obj;
        
        if( typeof( window.Event) === "function") {
            var e = new Event();
            if( e.initCustomEvent && typeof(e.initCustomEvent) === "function") {
                console.log( "Event has a initCustomEvent method");
            }
        }
    }
    
    return evt;
};